import { deserialize } from 'cerialize'

export class RegionsModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public utc_offset: number
	@deserialize public code: number | null
	@deserialize public is_deleted: boolean
	@deserialize public confirmed: boolean
}
